import { Link } from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import { Content } from '../../atoms/Content/index'
import { MenuPage } from '../MenuPage'
import { media } from '../../utils/media'
import Box from '../../atoms/Box'
import Image from '../../atoms/Image'

export class ChooseSitePage extends MenuPage {
  public renderContent() {
    return (
      <Content>
        <H1>{process.env.REACT_APP_LANGUAGE === 'es' ? 'Elige una sección' : 'Choose a section'}</H1>
        <Box h={20} w={100}  />
        <Container>
          <Box f1 />
          <Link to="/welcome-back">
            <Box>
              <MyImage
                name="chooseWebtips"
              />
              <SubTitle>{process.env.REACT_APP_LANGUAGE === 'es' ? 'L-WebTIPS' : 'WebTips'}</SubTitle>
            </Box>
          </Link>
          <Space  />

          <Link to="/kids">
            <Box>
              <MyImage
                name="chooseKids"
              />
              <SubTitle>{process.env.REACT_APP_LANGUAGE === 'es' ? 'Espacio para niños' : 'Kid\'s Space'}</SubTitle>
            </Box>
          </Link>
          <Box f1 />
        </Container>
      </Content>
    )
  }
}

const Container = styled.div `
  flex-direction: row;
  display: flex;

  @media screen and (max-width: 768px) {
  flex-direction: column;
  }
`

const MyImage = styled(Image)`
    height: 152px;
    width: 152px;
    align-self: center;
`


const Space = styled.div `
  width: 128px;
  display: flex;
  height: 40px;

  @media screen and (max-width: 768px) {
    width: 0px;
  }

`

const SubTitle = styled.span`
  font-family: Nunito;
  margin-top: 21px;
  font-size: 24px;
  color: #12385b;
  text-align: center;
`

const H1 = styled.h1`
  font-family: Nunito;
  font-weight: 900;
  font-size: 35px;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/ChooseSitePage/index.tsx